(function () {
  function initJaxAccordions() {
    document.querySelectorAll('[data-jax-accordion]').forEach((accordion) => {
      const items = accordion.querySelectorAll('[data-jax-accordion-item]');

      items.forEach((item) => {
        const oldButton = item.querySelector('[data-jax-accordion-button]');
        if (!oldButton) return;

        const button = oldButton.cloneNode(true);
        oldButton.replaceWith(button);

        button.addEventListener('click', () => {
          const isOpen = item.classList.contains('is-open');

          items.forEach((otherItem) => {
            const otherButton = otherItem.querySelector('[data-jax-accordion-button]');

            otherItem.classList.remove('is-open');
            if (otherButton) {
              otherButton.setAttribute('aria-expanded', 'false');
            }
          });

          if (!isOpen) {
            item.classList.add('is-open');
            button.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJaxAccordions);
  } else {
    initJaxAccordions();
  }

  document.addEventListener('shopify:section:load', initJaxAccordions);
})();